module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-grey@3x-7687de66.svg";